import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Spinner } from '../enums';
import { CustomHttpContext } from '../framework';
import { StringUtility } from '../utils';

const partialPageSpinnerHeaderKey = 'spinner';

export const partialPageSpinnerHeader = (spinnerName = '') => ({
  [partialPageSpinnerHeaderKey]: StringUtility.isNullOrEmpty(spinnerName)
    ? Spinner.PartialScreen
    : spinnerName,
});

@Injectable()
export class SpinnerInterceptorService implements HttpInterceptor {
  private activeRequests = 0;
  private currentSpinner: string | null = null;

  constructor(private readonly spinner: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(CustomHttpContext.DisableSpinner)) {
      return next.handle(req);
    }

    const spinnerToUse = req.headers.get(partialPageSpinnerHeaderKey) ?? Spinner.FullScreen;

    const isFullScreen = spinnerToUse === Spinner.FullScreen;

    const reqToUse = isFullScreen
      ? req
      : req.clone({
          headers: req.headers.delete(partialPageSpinnerHeaderKey),
        });

    this.activeRequests++;

    if (this.activeRequests === 1) {
      this.currentSpinner = spinnerToUse;
      this.spinner.show(spinnerToUse);
    }

    return next.handle(reqToUse).pipe(
      finalize(() => {
        this.activeRequests--;

        if (this.activeRequests <= 0) {
          this.activeRequests = 0;

          if (this.currentSpinner) {
            this.spinner.hide(this.currentSpinner);
          }

          this.currentSpinner = null;
        }
      }),
    );
  }
}
